import type { AlertTileVariant } from './AlertTile.types';

export const VARIANT_ICON_CLASS_MAP: Record<AlertTileVariant, string> = {
  danger: 'statusIndicatorDanger',
  info: 'statusIndicatorInfo',
};

export const ALERT_TILE_TEST_ID = 'alert-tile';
